module.exports = __webpack_public_path__ + "static/img/about-2.3ad4969.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about-2.png
// module id = B23f
// module chunks = 1